{
  "hero": {
    "title": "Convierte tu Catálogo de Productos en",
    "subtitle": "Asesores de Compra IA",
    "description": "Despliega una fuerza de ventas conversacional que vende — no solo chatea. En tu sitio web, redes sociales, WhatsApp y ChatGPT.",
    "createAssistant": "Crear Asistente IA",
    "bookDemo": "Reservar una Demo"
  },
  "nav": {
    "solutions": "Soluciones",
    "products": "Productos",
    "pricing": "Precios",
    "caseStudies": "Casos de Estudio",
    "blog": "Blog",
    "contact": "Contacto",
    "shoppingExpert": "Experto en Compras",
    "gptStore": "Tienda GPT"
  },
  "chat": {
    "greeting": "¡Hola! Soy tu asistente de compras con IA. Intenta preguntarme sobre productos como televisores, portátiles o cafeteras. ¿Cómo puedo ayudarte hoy?",
    "placeholder": "Escribe tu mensaje aquí...",
    "contact": {
      "heading": "Por favor comparte tu información de contacto"
    }
  },
  "sections": {
    "partners": {
      "title": "Confiado por plataformas líderes"
    },
    "gptPromo": {
      "title": "Lanza tu Marca en la Tienda GPT",
      "description": "Crea un asistente de compras GPT personalizado que muestre tus productos y convierta a los navegantes en compradores."
    },
    "solutions": {
      "title": "Soluciones por Industria",
      "subtitle": "Asesores de compra IA adaptados para tu industria",
      "electronics": {
        "title": "Electrónica y Tecnología",
        "description": "Ayuda a los clientes a navegar por especificaciones técnicas complejas y encontrar el dispositivo perfecto.",
        "items": [
          "Comparaciones inteligentes de productos",
          "Coincidencia de especificaciones técnicas",
          "Verificación de compatibilidad",
          "Recomendaciones de rendimiento"
        ]
      },
      "fashion": {
        "title": "Moda y Ropa",
        "description": "Proporciona consejos de estilo personalizados y recomendaciones de talla.",
        "items": [
          "Coincidencia y recomendaciones de estilo",
          "Orientación de talla y ajuste",
          "Consejos de tendencias de temporada",
          "Coordinación de conjuntos"
        ]
      },
      "home": {
        "title": "Hogar y Jardín",
        "description": "Guía a los clientes a través de decisiones de mejoras para el hogar y decoración.",
        "items": [
          "Consulta de diseño de habitaciones",
          "Recomendaciones de electrodomésticos",
          "Consejos de optimización de espacios",
          "Orientación de mantenimiento"
        ]
      },
      "agency": {
        "title": "Agencias y Socios",
        "description": "Soluciones de marca blanca para agencias que atienden a múltiples clientes minoristas.",
        "items": [
          "Gestión multi-cliente",
          "Opciones de marca personalizada",
          "Análisis e informes",
          "Soporte para socios de agencia"
        ]
      }
    },
    "platforms": {
      "title": "Plataforma soportada"
    },
    "valueProps": {
      "title": "¿Por qué Elegir Shopilots?",
      "subtitle": "Transforma tu experiencia minorista con IA que realmente vende",
      "conversion": {
        "title": "Aumenta las Conversiones",
        "description": "Convierte navegantes en compradores con recomendaciones de productos personalizadas y experiencias de compra guiadas.",
        "metric": "Tasa de Conversión"
      },
      "aov": {
        "title": "Incrementa el Valor Promedio",
        "description": "Sugerencias inteligentes de venta adicional y cruzada que resultan naturales y útiles para los clientes.",
        "metric": "Valor Promedio del Pedido"
      },
      "returns": {
        "title": "Reduce las Devoluciones",
        "description": "Una mejor coincidencia de productos significa que los clientes obtienen exactamente lo que necesitan a la primera.",
        "metric": "Tasa de Devolución"
      },
      "advantage": {
        "title": "La Ventaja de Shopilots",
        "description": "A diferencia de los chatbots genéricos, nuestra IA entiende tus productos y habla con la voz de tu marca.",
        "features": {
          "catalog": "Integración de catálogo en tiempo real",
          "sales": "Conversaciones enfocadas en ventas",
          "channels": "Despliegue multicanal",
          "analytics": "Análisis orientado a ingresos"
        }
      },
      "testimonial": {
        "title": "Éxito del Cliente",
        "quote": "Shopilots transformó nuestras ventas en línea. Los clientes encuentran productos más rápido y compran con más confianza.",
        "name": "Sarah Johnson",
        "position": "Directora de E-commerce"
      }
    }
  },
  "micro": {
    "demoMode": "Modo Demo"
  },
  "forms": {
    "name": "Nombre",
    "email": "Correo electrónico",
    "company": "Empresa",
    "phone": "Teléfono",
    "optional": "opcional",
    "thankYou": "¡Gracias!"
  },
  "buttons": {
    "sending": "Enviando...",
    "submit": "Enviar",
    "launchAssistant": "Lanza tu Asistente IA",
    "callUs": "Llámanos",
    "learnMore": "Saber Más",
    "getStarted": "Comenzar",
    "findSolution": "Encuentra tu Solución"
  },
  "footer": {
    "description": "Asesores de compra IA que venden — no solo chatean. Despliega en tu sitio web, redes sociales, WhatsApp y ChatGPT.",
    "solutions": "Soluciones",
    "resources": "Recursos",
    "contactUs": "Contáctanos",
    "copyright": "Todos los derechos reservados.",
    "links": {
      "privacyPolicy": "Política de Privacidad",
      "termsOfService": "Términos de Servicio",
      "sitemap": "Mapa del Sitio"
    }
  }
}